const delitem = (a, b) => {
	delete a[b];
};

export default delitem;
